import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import { reducer as toastrReducer } from 'react-redux-toastr';
import loginReducer from "../src/login/reducers/loginReducer"
import commonReducer from "./common/reducers/commonReducer";
import userManagementReducer from "./usermanagement/reducers/userManagementReducer";
import forgotPasswordReducer from "../src/login/reducers/forgotPasswordReducer";
import dashboardReducers from "../src/dashboard/reducers/dashboardReducers";
import postExaminationProcessObjectiveReducer from "../src/postExaminationProcessObjective/reducers/postExaminationProcessObjectiveReducer";
import interviewProcessReducer from './interviewProcess/reducers/interviewProcessReducer';
import recommendationProcessReducer from "../src/recommendationProcess/reducers/recommendationProcessReducer";
import statisticalReportReducer from "../src/statistical-report/reducers/statisticalReportReducer";
import accessRightsManagementReducer from './accessRightsManagement/reducers/accessRightsManagementReducer';
import administrationReducer from './administration/reducers/administrationReducer';
import testsReducer from './tests/reducers/testsReducer';

const rootReducer = combineReducers({
    toastr: toastrReducer,
    loginReducer: loginReducer,
    common: commonReducer,
    forgotPasswordReducer: forgotPasswordReducer,
    dashboardReducers: dashboardReducers,
    userManagementReducer: userManagementReducer,
    postExamProcessObjectReducer: postExaminationProcessObjectiveReducer,
    interviewProcessReducer: interviewProcessReducer,
    recommendationProcessReducer: recommendationProcessReducer,
    statisticalReducer: statisticalReportReducer,
    accessRightsManagementReducer: accessRightsManagementReducer,
    administrationReducer: administrationReducer,
    testsReducer: testsReducer

})

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;